(() => {
  const updateCountdown = (el) => {
    const target = el.dataset.targetDate;
    if (!target) return;

    const targetDate = new Date(target).getTime();
    if (Number.isNaN(targetDate)) return;

    const now = Date.now();
    const delta = Math.max(0, targetDate - now);

    const days = Math.floor(delta / (1000 * 60 * 60 * 24));
    const hours = Math.floor((delta / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((delta / (1000 * 60)) % 60);
    const seconds = Math.floor((delta / 1000) % 60);

    el.querySelector('[data-dd]')?.replaceChildren(document.createTextNode(String(days).padStart(2, '0')));
    el.querySelector('[data-hh]')?.replaceChildren(document.createTextNode(String(hours).padStart(2, '0')));
    el.querySelector('[data-mm]')?.replaceChildren(document.createTextNode(String(minutes).padStart(2, '0')));
    el.querySelector('[data-ss]')?.replaceChildren(document.createTextNode(String(seconds).padStart(2, '0')));
  };

  const mount = () => {
    const countdowns = document.querySelectorAll('[data-countdown]');
    if (!countdowns.length) return;

    countdowns.forEach((el) => updateCountdown(el));
    window.setInterval(() => {
      countdowns.forEach((el) => updateCountdown(el));
    }, 1000);
  };

  document.addEventListener('DOMContentLoaded', mount, { once: true });
})();
